// import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import { BrowserRouter } from "react-router-dom";
// import { Notifications } from "@mantine/notifications";
// import { MantineProvider } from "@mantine/core";

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <BrowserRouter>
//     <MantineProvider>
//       <Notifications />
//       <App />
//     </MantineProvider>
//   </BrowserRouter>
// );

import("./bootstrap");
